import { useApp } from '../../lib/app';

/** Header terminal switcher. Renders nothing for single-terminal companies. */
export function TerminalPicker() {
  const app = useApp();
  if (!app.multiTerminal) return null;
  return (
    <select className="terminal-picker" aria-label="Terminal" value={app.terminal} onChange={(e) => app.setTerminal(e.target.value)}>
      <option value="all">All terminals</option>
      {app.terminals.map((t) => (
        <option key={t.id} value={t.id}>{t.name}</option>
      ))}
    </select>
  );
}
